import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Syssh { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '程式代號 (SH001) 不可空白'}) 
    @MaxLength(20,{message: '程式代號 (SH001) 資料太長'})
    SH001: string = '';            // 程式代號 20 

    @MaxLength(60,{message: '名稱 (SH002) 資料太長'})
    SH002: string = '';            // 名稱 60 

    @MaxLength(255,{message: '網址 (SH003) 資料太長'})
    SH003: string = '';            // 網址 255 

    @MaxLength(255,{message: '備註 (SH004) 資料太長'})
    SH004: string = '';            // 備註 255 

    @MaxLength(0,{message: '流程圖/圖檔 (SH005) 資料太長'})
    SH005: string = '';            // 流程圖/圖檔 0 先用附件系統. 說明檔

    @MaxLength(1,{message: '類型 (SH006) 資料太長'})
    SH006: string = '1';            // 類型 1 [DEF:"1"]  1:網頁 2:圖檔 3:文件檔  4:html 5:markdown

    @MaxLength(4,{message: '保留 (SH007) 資料太長'})
    SH007: string = '';            // 保留 4 序號

    @MaxLength(10,{message: '文管代號 (SH008) 資料太長'})
    SH008: string = '';            // 文管代號 10 WK008 DocID     join MTR.WJ001

    @MaxLength(3,{message: '版次 (SH009) 資料太長'})
    SH009: string = '';            // 版次 3 WK009 Revision  join MTR.WJ002

    @MaxLength(255,{message: '功能簡介 (SH010) 資料太長'})
    SH010: string = '';            // 功能簡介 255 

    @MaxLength(12,{message: '功能分類 (SH011) 資料太長'})
    SH011: string = '';            // 功能分類 12 EX:基本資料 收銀單據

    @MaxLength(4,{message: '序號 (SH012) 資料太長'})
    SH012: string = '';            // 序號 4 

    @IsNotEmpty({message: '建檔者代號 (SH013) 不可空白'}) 
    @MaxLength(10,{message: '建檔者代號 (SH013) 資料太長'})
    SH013: string = '';            // 建檔者代號 10 PACKAGE:保留給套裝

    @MaxLength(20,{message: '用於系統 (SH014) 資料太長'})
    SH014: string = '';            // 用於系統 20 全部-收銀-客製-庫存-發票-會計-簽核

    @MaxLength(1,{message: '生效碼 (SH015) 資料太長'})
    SH015: string = 'N';            // 生效碼 1 [DEF:"N"]

    @MaxLength(1,{message: '客製程式碼 (SH016) 資料太長'})
    SH016: string = 'N';            // 客製程式碼 1 [DEF:"N"]

    SH017: string = '';            // 說明 0 

    @MaxLength(1,{message: '註記碼 (SH018) 資料太長'})
    SH018: string = 'N';            // 註記碼 1 [DEF:"N"]

    SH019: string = '';            // html內容 0 


}
